import { Configuration, CustomElementFactory, ElementRegistry } from "duice";
import { JsplumbElement } from "./JsplumbElement";
export class JsplumbElementFactory extends CustomElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    doCreateElement(htmlElement, bindData, context) {
        return new JsplumbElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-jsplumb`, new JsplumbElementFactory());
})();
//# sourceMappingURL=JsplumbElementFactory.js.map